import './NavBar.css'

import { MdMenu, MdFilterAlt } from "react-icons/md";
import { useLocation, useNavigate } from 'react-router-dom';

const NavBar = ({ state, changeState, setSideBar, title, prevDest, modulo, goBackOnePage, navTo, onFilterClick }) => {

    const navigate = useNavigate();
    const location = useLocation();

    const destination = modulo ? `/modulo/${ modulo }` : ( prevDest ? '/' + prevDest : '/' )

    let titulo = title || '';

    const getParentPath = () => {
        const parts = location.pathname.split('/').filter(Boolean);
        parts.pop();
        return '/' + parts.join('/')
    }

    const handleLogoClick = () => {

        if( navTo ){

            navigate(navTo);
            return;

        }

        if (goBackOnePage) {
            navigate(getParentPath());
            return;
        }

        const destination = modulo
            ? `/modulo/${modulo}`
            : `/${prevDest || ""}`;

        navigate(destination);
    }

    const handleClick = () => {
        if (changeState) {
            changeState(!state);
        }
        if (setSideBar) {
            setSideBar();
        }
    }

    return (
        <div className='navbar' >
            <img
                id='Navbar_logo'
                src='/Images/Logo.png'
                alt='Navbar Logo'
                title={"Navegar para " + destination}
                onClick={handleLogoClick}
                style={{ cursor: 'pointer' }}
            />

            <p className='versionText' >
                P-SIG | PALMONT SISTEMA INTEGRADO DE GESTÃO V.2026.1.2.0 - {titulo}
            </p>

            {(onFilterClick || changeState || setSideBar) && (
                <div className='navActions'>
                    {onFilterClick && (
                        <MdFilterAlt
                            size={32}
                            id="filterMenu"
                            onClick={onFilterClick}
                            role="button"
                            aria-label="Abrir filtros"
                        />
                    )}

                    {(changeState || setSideBar) && (
                        <MdMenu
                            size={40}
                            id="burgerMenu"
                            onClick={handleClick}
                            role="button"
                            aria-label="Abrir menu lateral"
                        />
                    )}
                </div>
            )}

        </div>
    )
}

export default NavBar;